import { render } from "./Page8.vue?vue&type=template&id=57c03e86"
import script from "./Page8.vue?vue&type=script&lang=js"
export * from "./Page8.vue?vue&type=script&lang=js"

import "./Page8.vue?vue&type=style&index=0&id=57c03e86&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__